import React, { Component } from 'react';
import LOOKUP from 'constants/lookup';
import GenericTable from 'screens/components/advanced/GenericTable';
import { mapDbClockIn } from 'utils/mappers';
import { connect } from 'react-redux';
import { ClipLoader } from 'react-spinners';
import DashDialog from 'screens/components/basic/DialogHeaderDashboard'
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import LinearProgress from '@mui/material/LinearProgress';
import { getTimesheet } from 'actions/DashboardActions';
class ClockIn extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const timesheet = this.props.timesheet;
        const onFloor = timesheet.filter(e => !e.clockOutTime).length;


        return (
            <div id="chart10" className="item m-0">
                <DashDialog
                    text="Clock In"
                    link="/report/employee-hours"
                    isReport={true}
                    refreshAction={() => this.props.getTimesheet(this.props.branchId)} />
                <div className="row m-0 p-0">
                    <div className="db-clockIn-container pt-4 pb-4 pl-0 text-center col-lg-6 col-md-6 col-sm-6 col-xs-6 position-relative">
                        <div>
                            {/* <AccessAlarmsIcon className="db-icon-lg d-block" /> */}
                            <span className="db-title">Clock-In</span>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label className="db-label text-white mt-5">Employees on floor</label>
                        <p className="db-info green-text">{onFloor}</p>
                    </div>
                </div>

                {/* Hide Table when there are no employees clock-in */}
                <div className="clockIn_height position-relative">
                    {timesheet.length === 0 ?
                        <div className="table_msg">
                            <h2>NO EMPLOYEES WORKING</h2>
                        </div>
                        :
                        this.props.loading
                            ?
                            // <LinearProgress variant="indeterminate" />
                            <ClipLoader
                                size={50}
                                color={'#123abc'}
                                loading={true}
                            />
                            :
                            <div className="p-0">
                                <GenericTable
                                    className="table_center"
                                    multiSelectable={false}
                                    enableSelectAll={false}
                                    selectable={false}
                                    stripedRows={true}
                                    columns={LOOKUP.shiftEdit.dashBoardTable}
                                    rows={mapDbClockIn(timesheet)}
                                />
                            </div>
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loading: state.common.dbClockIn > 0,
        branchId: state.common.branchId
    }
}

function mapDispatchToProps(dispatch){
    return {
        getTimesheet: (branchId) => dispatch(getTimesheet(branchId, true)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClockIn);